import Button from 'components/button/Button';
import { Modal } from 'components/modal/Modal';
import { Toast, ToastMessageReason } from 'helpers/toast';
import { copyToClipboard, MerchantCredentials } from './models';

type Props = {
    merchantName: string;
    credentials: MerchantCredentials;
    onClose: () => void;
};

const CredentialRow = ({ label, value }: { label: string; value: string }) => {
    const onCopy = async () => {
        const copied = await copyToClipboard(value);
        Toast.openToastMessage(
            copied ? `${label} copied` : 'Could not copy, please select and copy it manually',
            copied ? ToastMessageReason.VALID : ToastMessageReason.ERROR
        );
    };

    return (
        <div className="MerchantCredentialRow">
            <span className="MerchantCredentialLabel">{label}</span>
            <code className="MerchantCredentialValue notranslate" translate="no">
                {value}
            </code>
            <Button type="button" priority="secondary" variety="small" onClick={onCopy}>
                Copy
            </Button>
        </div>
    );
};

export const MerchantCredentialsModal = ({ merchantName, credentials, onClose }: Props) => (
    <Modal
        className="MerchantCredentialsModal"
        title={`${merchantName} QuickBuy credentials`}
        onCloseModal={onClose}
        closeOnClickOutside={false}
        customButtons={
            <div className="ModalNavigation">
                <Button type="button" onClick={onClose}>
                    Done
                </Button>
            </div>
        }
    >
        <p className="MerchantCredentialsWarning">
            Share these with the merchant for the QuickBuy set up and keep the secret private. You can
            view the secret again from the merchant list with two-factor authentication.
        </p>
        {credentials.apiKey && <CredentialRow label="API key" value={credentials.apiKey} />}
        <CredentialRow label="Secret" value={credentials.hashSecret} />
        {credentials.gatewayUsername && (
            <>
                <CredentialRow label="Portal username" value={credentials.gatewayUsername} />
                <p className="MerchantCredentialsNote">
                    The merchant portal sign-in details were emailed to{' '}
                    <span className="notranslate" translate="no">
                        {credentials.gatewayLoginEmail}
                    </span>
                    .
                </p>
            </>
        )}
    </Modal>
);
